// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../bundles/Auth/Auth.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as Json from "../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as AuthRoutes from "../app/Auth/AuthRoutes.res.js";
import * as Navigation from "../primitives/Navigation.res.js";
import * as Stdlib_Exn from "@rescript/runtime/lib/es6/Stdlib_Exn.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let UnauthorizedRequestError = /* @__PURE__ */Primitive_exceptions.create("Request.UnauthorizedRequestError");

let UnknownRequestError = /* @__PURE__ */Primitive_exceptions.create("Request.UnknownRequestError");

let RequestError = /* @__PURE__ */Primitive_exceptions.create("Request.RequestError");

let ClientError = /* @__PURE__ */Primitive_exceptions.create("Request.ClientError");

let serverErrorMessage = I18n.t("Wino did not respond, please reiterate your request.");

function decodeInvalidRequestFailure(json) {
  let dict = Json.decodeDict(json);
  let message = Json.flatDecodeDictFieldString(dict, "message");
  let kind = Json.flatDecodeDictFieldString(dict, "kind");
  let data = Stdlib_Option.map(Json.flatDecodeDictFieldDict(dict, "data"), prim => prim);
  if (message !== undefined && kind !== undefined) {
    return {
      message: message,
      kind: kind,
      data: data
    };
  }
}

function decodeInvalidRequestFailures(arr) {
  let failures = Stdlib_Array.filterMap(arr, decodeInvalidRequestFailure);
  if (failures.length === arr.length) {
    return failures;
  }
}

function decodeResult(json) {
  let data = Stdlib_Option.orElse(Stdlib_Option.orElse(Stdlib_Option.map(Json.flatDecodeDictFieldDict(Json.decodeDict(json), "data"), prim => prim), Stdlib_Option.map(Json.flatDecodeDictFieldArray(Json.decodeDict(json), "data"), prim => prim)), Stdlib_Option.map(Json.flatDecodeDictField(Json.decodeDict(json), "data", Json.decodeNull), param => null));
  let errors = Json.flatDecodeDictFieldArray(Json.decodeDict(json), "errors");
  if (data !== undefined) {
    if (errors !== undefined) {
      return {
        TAG: "Error",
        _0: undefined
      };
    } else {
      return {
        TAG: "Ok",
        _0: data
      };
    }
  } else if (errors !== undefined) {
    return {
      TAG: "Error",
      _0: decodeInvalidRequestFailures(errors)
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

function make(endpoint, methodOpt, body, authTokenRequiredOpt, skipMalformedOkResultOpt) {
  let method = methodOpt !== undefined ? methodOpt : "GET";
  let authTokenRequired = authTokenRequiredOpt !== undefined ? authTokenRequiredOpt : true;
  let skipMalformedOkResult = skipMalformedOkResultOpt !== undefined ? skipMalformedOkResultOpt : false;
  let jwt = Auth.getJwt();
  if (Stdlib_Option.isNone(jwt) && authTokenRequired) {
    Navigation.openRoute(AuthRoutes.logoutSessionExpiredRoute);
    return Future.value({
      TAG: "Error",
      _0: "JwtAuthenticationRedirection"
    });
  }
  let abortController = new AbortController();
  let abortSignal = abortController.signal;
  let tmp;
  tmp = body !== undefined && body.TAG !== "JsonBody" ? body._0.type : "application/json";
  let headers = new Headers({
    Authorization: jwt !== undefined && authTokenRequired ? `Bearer ` + jwt : "",
    "Content-Type": tmp
  });
  let tmp$1;
  tmp$1 = body !== undefined ? (
      body.TAG === "JsonBody" ? Primitive_option.some(Json.stringify(body._0)) : Primitive_option.some(body._0)
    ) : undefined;
  let init_method = method;
  let init_headers = Primitive_option.some(headers);
  let init_signal = Primitive_option.some(abortSignal);
  let init = {
    method: init_method,
    body: tmp$1,
    headers: init_headers,
    signal: init_signal
  };
  let fetchPromise = fetch(endpoint, init).then(response => {
    let status = response.status;
    let contentType = response.headers.get("content-type");
    if (status === 401) {
      return Promise.reject({
        RE_EXN_ID: UnauthorizedRequestError
      });
    } else if (contentType == null) {
      return Promise.reject({
        RE_EXN_ID: UnknownRequestError
      });
    } else if (contentType.startsWith("application/json")) {
      return response.json();
    } else if (contentType.startsWith("text/plain") && status >= 500) {
      return response.text().then(text => Promise.reject({
        RE_EXN_ID: RequestError,
        _1: text
      }));
    } else {
      return Promise.reject({
        RE_EXN_ID: UnknownRequestError
      });
    }
  });
  return Future.map(Future.map(Future.mapError(Future.make(resolve => {
    Stdlib_Promise.$$catch(fetchPromise.then(ok => resolve({
      TAG: "Ok",
      _0: ok
    })), error => {
      resolve({
        TAG: "Error",
        _0: error
      });
      return Promise.resolve();
    });
    return () => {
      abortController.abort();
    };
  }), true, error => {
    let error$1 = Primitive_exceptions.internalToException(error);
    if (error$1.RE_EXN_ID !== Stdlib_Exn.$$Error) {
      return error$1;
    }
    let message = error$1._1.message;
    if (message !== undefined) {
      return {
        RE_EXN_ID: ClientError,
        _1: message
      };
    } else {
      return {
        RE_EXN_ID: UnknownRequestError
      };
    }
  }), true, result => {
    if (result.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: result._0
      };
    }
    let error = result._0;
    if (error.RE_EXN_ID === UnauthorizedRequestError) {
      return {
        TAG: "Error",
        _0: "JwtAuthenticationRedirection"
      };
    } else if (error.RE_EXN_ID === ClientError) {
      return {
        TAG: "Error",
        _0: {
          TAG: "ClientError",
          _0: error._1
        }
      };
    } else if (error.RE_EXN_ID === RequestError) {
      return {
        TAG: "Error",
        _0: {
          TAG: "ServerError",
          _0: error._1
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: "UnexpectedServerError"
      };
    }
  }), true, result => {
    if (result.TAG !== "Ok") {
      return result;
    }
    let ok = result._0;
    let match = decodeResult(ok);
    if (match.TAG === "Ok") {
      let data = match._0;
      if (data !== undefined) {
        return {
          TAG: "Ok",
          _0: data
        };
      }
    } else {
      let failures = match._0;
      if (failures !== undefined) {
        return {
          TAG: "Error",
          _0: {
            TAG: "InvalidRequestFailures",
            _0: failures
          }
        };
      }
    }
    if (skipMalformedOkResult === false) {
      return {
        TAG: "Error",
        _0: "MalformedResponse"
      };
    } else {
      return {
        TAG: "Ok",
        _0: ok
      };
    }
  });
}

function makeBlob(endpoint, authTokenRequiredOpt) {
  let authTokenRequired = authTokenRequiredOpt !== undefined ? authTokenRequiredOpt : true;
  let jwt = Auth.getJwt();
  if (Stdlib_Option.isNone(jwt) && authTokenRequired) {
    Navigation.openRoute(AuthRoutes.logoutSessionExpiredRoute);
    return Future.value({
      TAG: "Error",
      _0: "JwtAuthenticationRedirection"
    });
  }
  let abortController = new AbortController();
  let abortSignal = abortController.signal;
  let headers = new Headers({
    Authorization: jwt !== undefined && authTokenRequired ? `Bearer ` + jwt : ""
  });
  let init_method = "GET";
  let init_headers = Primitive_option.some(headers);
  let init_signal = Primitive_option.some(abortSignal);
  let init = {
    method: init_method,
    headers: init_headers,
    signal: init_signal
  };
  let fetchPromise = fetch(endpoint, init).then(response => {
    let status = response.status;
    if (status !== 401) {
      if (status >= 400) {
        return Promise.reject({
          RE_EXN_ID: UnknownRequestError
        });
      } else {
        return response.blob();
      }
    } else {
      return Promise.reject({
        RE_EXN_ID: UnauthorizedRequestError
      });
    }
  });
  return Future.map(Future.mapError(Future.make(resolve => {
    Stdlib_Promise.$$catch(fetchPromise.then(ok => resolve({
      TAG: "Ok",
      _0: ok
    })), error => {
      resolve({
        TAG: "Error",
        _0: error
      });
      return Promise.resolve();
    });
    return () => {
      abortController.abort();
    };
  }), true, error => {
    let error$1 = Primitive_exceptions.internalToException(error);
    if (error$1.RE_EXN_ID !== Stdlib_Exn.$$Error) {
      return error$1;
    }
    let message = error$1._1.message;
    if (message !== undefined) {
      return {
        RE_EXN_ID: ClientError,
        _1: message
      };
    } else {
      return {
        RE_EXN_ID: UnknownRequestError
      };
    }
  }), true, result => {
    if (result.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: result._0
      };
    }
    let error = result._0;
    if (error.RE_EXN_ID === UnauthorizedRequestError) {
      return {
        TAG: "Error",
        _0: "JwtAuthenticationRedirection"
      };
    } else if (error.RE_EXN_ID === ClientError) {
      return {
        TAG: "Error",
        _0: {
          TAG: "ClientError",
          _0: error._1
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: "UnexpectedServerError"
      };
    }
  });
}

export {
  serverErrorMessage,
  decodeInvalidRequestFailure,
  decodeInvalidRequestFailures,
  decodeResult,
  make,
  makeBlob,
}
/* serverErrorMessage Not a pure module */
